// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2lgkF","button_text":"Button_button_text__2xg86","button_icon":"Button_button_icon__3o8J7"};